import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定の決済（ポイントカード・決済手段）に関するFeatureFlagsを作成します。
export function createPartnerConfigFeatureFlagsPaymentPart(spec: ServiceSpecification) {
  const pointCard = () => {
    if (spec.payment?.pointCardSetting?.case === 'enablePointCard') {
      return spec.payment.pointCardSetting.value
    }
    return undefined
  }

  return {
    get displayEarnedPointInReceipt(): boolean {
      return pointCard()?.earnedPointInReceipt.case === 'enableEarnedPointInReceipt'
    },
    get enableCashOnDeliveryFee(): boolean {
      const methods = spec.payment?.availablePaymentMethods ?? []
      return methods.some(
        (m) => m.method.case === 'cashOnDelivery' && m.method.value.fee.case === 'withFee',
      )
    },
    get isDisplaySplitEarnedPoint(): boolean {
      return pointCard()?.uiSetting?.showSplitEarnedPoint === true
    },
    get enableLinkPointInfo(): boolean {
      return spec.payment?.pointCardSetting?.case === 'enablePointCard'
    },
    get enableRedeemPoint(): boolean {
      return pointCard()?.enableRedeem === true
    },
    get enableBankAccountTransfer(): boolean {
      const methods = spec.payment?.availablePaymentMethods ?? []
      return methods.some((m) => m.method.case === 'bankAccountTransfer')
    },
  }
}
